import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import ModalActions from 'reducers/Modal'
import { Button, Tonality, Modal } from '@dsny/dsny-component-library'
import { Check, Warning, Close } from '@dsny/dsny-component-library/icons'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { trackEvent } from 'utils/segmentService'
import {
  XButtonWrapper,
  ButtonWrapper,
  ListTitleWrapper,
  ModalWrapper,
  InviteIconBg,
  Container
} from './InviteConnection.styles'

const InviteState = ({ isCancel }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()

  const showInviteListStateModal = useSelector(
    (state) => state.modal?.showInviteListStateModal
  )
  const showInviteListModal = useSelector(
    (state) => state.modal?.showInviteListModal
  )

  const trackInviteStateClick = (type) => {
    trackEvent('Click', {
      source: 'invite_state',
      type
    })
  }

  const handleCancelClick = () => {
    trackInviteStateClick('close')
    dispatch(ModalActions.toggleInviteListStateModal())
    dispatch(ModalActions.toggleInviteListModal())
  }

  const handleState = () => {
    trackInviteStateClick('continue')
    dispatch(ModalActions.toggleInviteListStateModal())
    if (!showInviteListModal) {
      dispatch(ModalActions.toggleInviteListModal())
    }
  }

  const renderModalContent = (showCancelState) =>
    showCancelState ? (
      <ModalWrapper $state $isMobile={isMobile} style={{ marginTop: 0 }}>
        <Container>
          <InviteIconBg>
            <Warning width={24} color={theme.colors.neutralW20} />
          </InviteIconBg>
          <ListTitleWrapper $isMobile={isMobile}>
            <Tonality.UIHeading
              headingStyle="headline5"
              color={theme.colors.neutralW90}
              style={{ marginBottom: 8 }}>
              {t('invite-connection.invite-cancel-title')}
            </Tonality.UIHeading>
            <Tonality.UIText textStyle="label" color={theme.colors.neutralW70}>
              {t('invite-connection.invite-cancel-desc')}
            </Tonality.UIText>
          </ListTitleWrapper>
        </Container>
        <ButtonWrapper $state>
          <Button
            variant="secondary"
            setting="player"
            mode="dark"
            onClick={handleCancelClick}>
            {t('invite-connection.invite-close')}
          </Button>
          <Button
            variant="primary"
            setting="player"
            mode="dark"
            onClick={handleState}>
            {t('invite-connection.invite-continue')}
          </Button>
        </ButtonWrapper>
      </ModalWrapper>
    ) : (
      <ModalWrapper $state $isMobile={isMobile} style={{ marginTop: 0 }}>
        <Container>
          <InviteIconBg>
            <Check width={24} color={theme.colors.neutralW20} />
          </InviteIconBg>
          <ListTitleWrapper $isMobile={isMobile}>
            <Tonality.UIHeading
              headingStyle="headline5"
              color={theme.colors.neutralW90}
              style={{ marginBottom: 8 }}>
              {t('invite-connection.invite-success-title')}
            </Tonality.UIHeading>
            <Tonality.UIText textStyle="label" color={theme.colors.neutralW70}>
              {t('invite-connection.invite-success-desc')}
            </Tonality.UIText>
          </ListTitleWrapper>
        </Container>
      </ModalWrapper>
    )

  return (
    <>
      <Modal
        isOpen={showInviteListStateModal}
        analyticsModalType="invite_state"
        trackEvent={trackEvent}
        containerStyles={{
          padding: isMobile ? '24px 16px' : '72px 64px 64px',
          background: theme.colors.neutralW20,
          border: `1px solid ${theme.colors.neutralW30}`,
          width: isMobile ? '100%' : 676
        }}
        onClose={handleCancelClick}>
        {!isCancel && (
          <XButtonWrapper onClick={handleCancelClick}>
            <Close width={14} color={theme.colors.neutralW80} />
          </XButtonWrapper>
        )}
        {isCancel ? renderModalContent(true) : renderModalContent(false)}
      </Modal>
    </>
  )
}

export default InviteState

InviteState.propTypes = {
  isCancel: PropTypes.bool.isRequired
}
